module.exports = __webpack_public_path__ + "static/img/menzhenjiaofei.e5b99111.png";